import { HttpClient } from '@/shared/lib/http-client';

export const fetchCompanyBranches = async (companyId) => {
  const response = await HttpClient.get('/company-branches', {
    companyId,
  });

  return response.data?.data;
};
